export const includeSignupInList = (
  list: Array<object>,
  content: object,
  position: number
) => {
  const newList = list.splice(position, 0, content);

  return newList;
};
